<h2 class="modal-title">Brak uprawnień.</h2>
<div class="modal-content">
  Nie masz uprawnień do wykonania tej operacji!
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="onClick()">OK</button>
</div>
